import { t } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  uuid: Yup.string(),
  name: Yup.string().required(t('validation.class.nameRequired')),
  shortName: Yup.string().required(t('validation.class.shortNameRequired')),
});
